// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3oRhK","name":"ConsentHeader_name__1UUe9","birthday":"ConsentHeader_birthday__2Wxgp","skeleton":"ConsentHeader_skeleton__1pXbv"};